import { render, staticRenderFns } from "./ServiceVue.vue?vue&type=template&id=a80470e2"
import script from "./ServiceVue.vue?vue&type=script&lang=js"
export * from "./ServiceVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports